import React, { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import Modal from './Modal';
import helpers from 'app/utils/helpers';
import notification from 'app/config/notification';
import { clearFiles } from 'app/store/slices/forms';
import { hideLoading, showLoading } from 'app/store/slices/settings';
import { STATUS_CODES } from 'app/config/status';
import { updateRequestDetails } from 'app/store/slices/requests';
import { errorHandler } from 'app/utils/errorHandler';
import certificationEndpoints from 'app/api/services/certificationEndpoints';
import requestEndpoints from 'app/api/services/requestEndpoints';
import filesEndpoint from 'app/api/services/filesEndpoint';

import styles from './../styles';
import sectorEndpoint from '../../../../../api/services/sectorEndpoint';
import generalEndpoints from '../../../../../api/services/generalEndpoints';
import lineEndpoint from '../../../../../api/services/lineEndpoint';
import { DOCUMENT_TYPES } from '../../../../../utils/constants';
import { downloadFile } from "../../../../../utils/forms/files";

const useStyles = makeStyles(styles);

function LineCertification(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { intl, validateDocuments } = props;

  const [certificationSelected, setCertificationSelected] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingDirector, setLoadingDirector] = useState(true);
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [updateFile, setUpdateFile] = useState(false);
  const [sending, setSending] = useState(false);
  const [directors, setDirectors] = useState([]);
  const [generalDirector, setGeneralDirector] = useState({});
  const [alternativeDirector, setAlternativeDirector] = useState({});
  const [documentTypes, setDocumentTypes] = useState([]);
  const [lines, setLines] = useState([]);
  const [permissionary, setPermissionary] = useState({});

  const [allCertificationChecked, setAllCertificationChecked] = useState(false);
  const [checkedCertification, setCheckedCertification] = useState([]);
  const [directorToSign, setDirectorToSign] = useState();

  const filesStore = useSelector(state => state.forms.files);
  const request = useSelector(state => state.requests.details);

  const requestJsonData = useMemo(() => {
    return request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};
  }, [request]);

  const canEdit = useMemo(() => {
    return request?.situacao?.boEdicaoPortalInterno;
  }, [request]);

  const certificationNeedSignature = useMemo(() => {
    return true;
  }, []);

  const [canEditCertificate, setCanEditCertificate] = useState(() => {
    return canEdit &&
      (request.cdSituacao === STATUS_CODES.EM_ANALISE ||
        request.cdSituacao === STATUS_CODES.RETORNO_DIRETOR_GERAL ||
        request.cdSituacao === STATUS_CODES.AGUARDANDO_AJUSTES_DOCUMENTO);
  });

  const [canSendToAssignCertificate, setCanSendToAssignCertificate] = useState(() => {
    return canEdit &&
      (request.cdSituacao === STATUS_CODES.EM_ANALISE ||
        request.cdSituacao === STATUS_CODES.RETORNO_DIRETOR_GERAL ||
        request.cdSituacao === STATUS_CODES.AGUARDANDO_AJUSTES_DOCUMENTO);
  });

  const getCertificates = useCallback(async () => {
    const response = await certificationEndpoints.getCertificates(request.cdSolicitacao);
    if (response.status === 200) {
      const certificatesRows = response.data;
      setRows(certificatesRows);
    }
  }, [request]);

  useEffect(() => {
    (async () => {
      if(Object.keys(permissionary).length === 0 && request && request.jsonSolicitacao){
        const requestJsonData = JSON.parse(request.jsonSolicitacao);
        const doc = requestJsonData.deCpfCnpj;
        if(doc){
          const response = await lineEndpoint.getPermissionaryByDocument(doc);
          if(response && response.status === 200){
            setPermissionary(response.data);
          }
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[request]);

  useEffect(() => {
    (async () => {
      if(documentTypes.length === 0){
        const responseDocs = await generalEndpoints.getDocumentTypesLine();
        if (responseDocs?.status === 200 && responseDocs?.data) {
          setDocumentTypes(responseDocs.data);
        }
        const responseLines = await lineEndpoint.getLines({
          page: 0, size: 100, request: {
            cdEmpresa: request.cdEmpresa,
            cdServico: request.cdServico
          }
        });
        if(responseLines && responseLines.status === 200){
          const { content } = responseLines.data;
          setLines(content);
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(clearFiles());
    (async () => {
      setLoading(true);
      try {
        await getCertificates();

        let tempDirectors = [];
        const response = await sectorEndpoint.getDirectorsByService(request.cdServico);
        if (response.status === 200) {
          let directorsResponse = response.data;
          setDirectors(directorsResponse);
          tempDirectors = [...directorsResponse];
        }

        const responseGeneral = await sectorEndpoint.getGeneralDirector();
        if (responseGeneral.status === 200  && responseGeneral.data !== "") {
          let directorsResponse = responseGeneral.data;
          setGeneralDirector(directorsResponse);
          tempDirectors.push(directorsResponse);
        }

        const responseAlternative = await sectorEndpoint.getAlternativeDirector();
        if (responseAlternative.status === 200  && responseAlternative.data !== "") {
          let directorsResponse = responseAlternative.data;
          setAlternativeDirector(directorsResponse);
          tempDirectors.push(directorsResponse);
        }

        setDirectors(tempDirectors);

      } catch (error) {
        notification(
          intl.formatMessage({ id: 'MESSAGES.CERTIFICATION.PROBLEM_GET_CERTIFICATES' }),
          {
            toastId: 'PROBLEM_GET_CERTIFICATES',
            type: 'error',
          },
        );
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, getCertificates]);

  const handleClose = () => {
    setOpen(false);
    setUpdateFile(false);
    dispatch(clearFiles());
    setCertificationSelected(null);
  };

  const openModal = row => {
    const certificateRow = { ...row, updateFile: false };
    setCertificationSelected(certificateRow);
    setOpen(true);
  };

  const onSave = async (values) => {
    if (!canEdit) return;

    try {
      if(values.cdTipoDocumento){
        let canSave = false;
        if(values.cdCertificado){
          const found = rows.find(cert => values.cdCertificado === cert.cdCertificado);
          if(found){
            canSave = true;
          }
        }

        if(!canSave){
          const found = rows.filter(cert => {
            let temp = Number(cert.cdTipoDocumento) === Number(values.cdTipoDocumento);
            if(values.cdCertificado){
              temp = temp && (values.cdCertificado !== cert.cdCertificado);
            }
            return temp;
          });
          if(found && found.length > 0){
            notification("O tipo selecionado já encontra-se na listagem de documentos", {
              type: 'error',
            });
            return;
          }
        }
      }

      if(!filesStore[0] && ! values.idFileCrc){
        notification("O envio do arquivo é obrigatório", {
          type: 'error',
        });
        return;
      }

      setSending(true);
      const sendingData = new FormData();
      if (values.cdCertificado) sendingData.append('cdCertificado', values.cdCertificado);
      if (values.idFileCrc) sendingData.append('idFileCrc', values.idFileCrc);
      if (values.idGdoc) sendingData.append('idGdoc', values.idGdoc);
      if (values.deObservacao) sendingData.append('deObservacao', values.deObservacao);
      if (values.cdTipoDocumento) sendingData.append('cdTipoDocumento', values.cdTipoDocumento);
      if (values.nuDocumentoExtra) sendingData.append('nuDocumentoExtra', values.nuDocumentoExtra);

      if (values.cdLinhaDocumentoExtra) {
        let fieldCdDocumentoExtra = 'cdLinhaDocumentoExtra';
        let cdLinhaDocumentoExtra = values.cdLinhaDocumentoExtra;
        const docType = documentTypes.filter(doc => String(doc.cdTipoDocumento) === String(values.cdTipoDocumento));
        if(docType && docType.length > 0){
          if(docType[0].boPermissionario && Object.keys(permissionary).length > 0){
            fieldCdDocumentoExtra = 'cdPermissionarioDocExtra';
            cdLinhaDocumentoExtra = permissionary.cdLinhaPermissionario;
          }
        }
        sendingData.append(fieldCdDocumentoExtra, cdLinhaDocumentoExtra);
      }
      sendingData.append('cdSolicitacao', request.cdSolicitacao);
      if (requestJsonData.cdTipoEmpresa) {
        sendingData.append('cdTipoEmpresa', requestJsonData.cdTipoEmpresa);
      }
      if (requestJsonData.cdTipoPessoaFisica) {
        sendingData.append('cdTipoPessoaFisica', requestJsonData.cdTipoPessoaFisica);
      }
      sendingData.append('dtEmissaoCrc', `${moment.utc(values.dtEmissaoCrc).format('YYYY-MM-DD')} 12:00:00`);
      sendingData.append('dtVencimentoCrc', (values.dtVencimentoCrc ? `${moment.utc(values.dtVencimentoCrc).format('YYYY-MM-DD')} 12:00:00` : ''));
      if (filesStore[0]) {
        const convertedFile = helpers.dataURItoBlob(filesStore[0].file);
        const fileName = filesStore[0].fileName ? filesStore[0].fileName : filesStore[0].name;
        sendingData.append('file', convertedFile, fileName);
      } else {
        try {
          if (values.idFileCrc && !values.updateFile) {
            const fileData = await filesEndpoint.getFileData(values.idFileCrc);
            if (fileData?.status === 200 && fileData?.data) {
              const responseBlob = await filesEndpoint.getFileBlob(values.idFileCrc);
              if (responseBlob?.status === 200 && responseBlob?.data) {
                const blob = new Blob([responseBlob.data], { type: 'application/pdf' });
                sendingData.append('file', blob, fileData.data.name);
              }
            }
          }
        } catch (error) {
        }
      }

      const response = await certificationEndpoints.saveCertificate(sendingData);
      if (response.status === 200) {
        notification(intl.formatMessage({ id: 'MESSAGES.CERTIFICATION.SUCCESSFUL_SAVED' }), {
          toastId: 'SUCCESSFUL_SAVED',
          type: 'success',
        });
        setAllCertificationChecked(false);
        setCheckedCertification([]);
        await getCertificates();
      }
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    }
    handleClose();
    setSending(false);
  };

  const sendToAssign = async () => {
    const documentsOK = await validateDocuments();
    if (!documentsOK) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.MISSING_DOCUMENTS_TO_APPROVE' }), {
        toastId: 'MISSING_DOCUMENTS_TO_APPROVE',
        type: 'warning',
      });
      dispatch(hideLoading());
      return;
    }

    try {
      dispatch(showLoading());
      const data = {
        cdDiretor: directorToSign,
        cdSolicitacao: request.cdSolicitacao,
        certificados: [],
      };

      checkedCertification.forEach(c => {
        data.certificados.push(c.cdCertificado);
      });

      if (data.certificados.length > 0) {
        const response = await certificationEndpoints.signListCertificate(data);
        if (response && response.status === 200) {
          notification(
            intl.formatMessage({ id: 'MESSAGES.CERTIFICATION.SUCCESSFUL_SEND_SIGNATURE' }),
            {
              toastId: 'SUCCESSFUL_SEND_SIGNATURE',
              type: 'success',
            },
          );
        }
        setCanEditCertificate(false);
        setCanSendToAssignCertificate(false);
        getCertificates();
        const responseRequest = await requestEndpoints.findRequest(
          { cdSolicitacao: request.cdSolicitacao },
          '',
        );
        if (responseRequest.status === 200 && responseRequest.data) {
          await dispatch(updateRequestDetails(responseRequest.data));
        }
      }
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    }
    dispatch(hideLoading());
  };

  const downloadFile_ = async idFileCrc => {
    await downloadFile({ idFile: idFileCrc, dispatch }, null);
  };

  const verifyDirectorToSign = ({ listChecked = [] }) => {
    setLoadingDirector(true);
    const hasQh = listChecked.filter(cert => cert.cdTipoDocumento === DOCUMENT_TYPES.APOSTILA_QUADRO_HORARIO).length > 0;
    const hasCepe = listChecked.filter(cert => cert.cdTipoDocumento === DOCUMENT_TYPES.CEPE).length > 0;
    const hasConductor = listChecked.filter(cert => cert.cdTipoDocumento === DOCUMENT_TYPES.CARTEIRA_CONDUTOR_SUBSTITUTO).length > 0;

    const tempDirectors = directors.map(dir => {
      const temp = _.cloneDeep(dir);
      let hide = false;
      if(hasQh && !hasCepe && !hasConductor){
        if(dir.cdUsuario === generalDirector.cdUsuario || dir.cdUsuario === alternativeDirector.cdUsuario){
          hide = true;
        }
      } else if (!hasQh && (hasCepe || hasConductor)){
        if(dir.cdUsuario !== generalDirector.cdUsuario && dir.cdUsuario !== alternativeDirector.cdUsuario){
          hide = true;
        }
      }
      temp.hide = hide;
      return temp;
    });
    setDirectors(tempDirectors);
    const validDirectors = tempDirectors.filter(director => !director.hide);
    if(validDirectors.length > 0){
      setDirectorToSign(validDirectors[0].cdUsuario);
    }
    setLoadingDirector(false);
  }

  const checkAll = e => {
    let key = 'cdCertificado';
    let newChecked = [...checkedCertification];
    rows.forEach(elem => {
      if (e?.target?.checked) {
        setAllCertificationChecked(true);
        const element = _.find(checkedCertification, [key, elem[key]]);
        if (element) return;
        newChecked.push(elem);
      }
    });
    if (!e?.target?.checked) {
      newChecked = [];
      setAllCertificationChecked(false);
    }
    verifyDirectorToSign({ listChecked: newChecked });
    setCheckedCertification(newChecked);
  };

  const handleToggleCheckbox = row => {
    const currentIndex = checkedCertification.indexOf(row);
    const newChecked = [...checkedCertification];
    if (currentIndex === -1) {
      newChecked.push(row);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    verifyDirectorToSign({ listChecked: newChecked });
    setCheckedCertification(newChecked);
  };

  const handleChangeDirector = e => {
    setDirectorToSign(e.target.value);
  }

  const renderListCertification = () => {
    return rows.map((row, index) => {
      let certificationStatus = 'Aguardando envio para assinatura';
      if(STATUS_CODES.APROVADO === request.cdSituacao
        || STATUS_CODES.REPROVADO === request.cdSituacao
        || STATUS_CODES.CANCELADO === request.cdSituacao){
        certificationStatus = 'Solicitação finalizada';
      }
      const alreadySigned = row.boAssinado;
      let hideBtnSendSignature = false;

      let canEditThisCertificate = true; //!row.cdLinhaQuadroHorario && !row.cdCondutorSubstituto && !row.cdCepe && !row.cdLinhaApostila;

      if (alreadySigned) {
        certificationStatus = 'Documento assinado';
        canEditThisCertificate = false;
      } else {
        if (request.cdSituacao === STATUS_CODES.AGUARDANDO_ASSINATURA_DOCUMENTO) {
          if(!row.dtEnvioAssinatura) hideBtnSendSignature = true;
          canEditThisCertificate = false;
          certificationStatus = 'Aguardando assinatura';
        }
      }
      let certificationNumber = String(row.cdCertificado).padStart(3, '0');
      if (row.nuDocumentoExtra) {
        certificationNumber = row.nuDocumentoExtra;
      }

      const documentType = documentTypes.find(doc => doc.cdTipoDocumento === row.cdTipoDocumento);

      let lineName = null;
      if(row.cdLinhaDocumentoExtra){
        lineName = lines.filter(line => line.cdLinha === row.cdLinhaDocumentoExtra).map(line => line.deDescricao);
      }

      return (
        <TableRow key={`cert-${index}`} className={classes.tableRow}>
          {certificationNeedSignature && (
            <TableCell align='center'>
              {alreadySigned ? ( <Checkbox edge='start' disabled />
              ) : (
                <Checkbox
                  edge='start'
                  checked={checkedCertification.indexOf(row) !== -1}
                  tabIndex={-1}
                  disableRipple
                  disabled={!canEdit}
                  onClick={() => handleToggleCheckbox(row)}
                  inputProps={{ 'aria-labelledby': `cert-${index}` }}
                />
              )}
            </TableCell>
          )}
          <TableCell align='center'>{certificationNumber}</TableCell>
          <TableCell align='center'>{moment.utc(row.dtSolicitacao).format('DD/MM/YYYY')}</TableCell>
          <TableCell align='left'>
            <>
              {documentType && <b>{documentType.nmTipoDocumento}</b>}
              {lineName && !!lineName.length && <div>Linha: {lineName}</div>}
            </>
          </TableCell>
          {certificationNeedSignature && (
            <TableCell align='right'>
              <div className={classes.msgSignature}>
                {!hideBtnSendSignature && <>
                  <img
                    alt=''
                    src={process.env.PUBLIC_URL + '/img/signature.png'}
                    style={{ height: '30px' }}
                  />
                  {certificationStatus}
                </>}
              </div>
            </TableCell>
          )}
          <TableCell align='right'>
            {row.idFileCrc && (
              <Button
                variant='contained'
                color='secondary'
                className={classes.btnSigleAction}
                size='small'
                onClick={() => downloadFile_(row.idFileCrc)}
              >
                <PictureAsPdfIcon fontSize='inherit' />
              </Button>
            )}
            {canEditCertificate && canEditThisCertificate && (
              <Button
                variant='contained'
                color='primary'
                className={classes.btnSigleAction}
                size='small'
                onClick={() => openModal(row)}
              >
                <EditIcon fontSize='inherit' />
              </Button>
            )}
          </TableCell>
        </TableRow>
      );
    });
  };

  return (
    <>
      <Modal
        {...props}
        classes={classes}
        open={open}
        onClose={handleClose}
        onSave={onSave}
        certification={certificationSelected}
        request={request}
        requestJsonData={requestJsonData}
        downloadFile={downloadFile_}
        updateFile={updateFile}
        setUpdateFile={setUpdateFile}
        documentTypes={documentTypes}
        lines={lines}
      />
      {loading && (
        <div className={classes.centerProgress}>
          <CircularProgress size={20} />
        </div>
      )}
      {!loading && (
        <div className={classes.reponsiveTable}>
          <Table className={classes.table} aria-label='customized table'>
            <TableHead>
              <TableRow className={classes.tableRow}>
                {certificationNeedSignature && (
                  <TableCell className={classes.headTableCell} align='center'>
                    <FormControlLabel
                      className={classes.filterLabel}
                      onClick={event => {
                        event.stopPropagation();
                        checkAll(event);
                      }}
                      disabled={!canEdit}
                      onFocus={event => event.stopPropagation()}
                      control={<Checkbox color='default' checked={allCertificationChecked} />}
                      label=''
                    />
                  </TableCell>
                )}
                <TableCell className={classes.headTableCell} align='center'>
                  Número
                </TableCell>
                <TableCell className={classes.headTableCell} align='center'>
                  Data Solicitação
                </TableCell>
                <TableCell className={classes.headTableCell} align='left'>
                  Tipo
                </TableCell>
                {certificationNeedSignature && (
                  <TableCell
                    className={classes.headTableCell}
                    align='left'
                    style={{ minWidth: '295px' }}
                  >
                    Situação do certificado
                  </TableCell>
                )}
                <TableCell
                  className={classes.headTableCell}
                  align='left'
                  style={{ minWidth: '110px' }}
                >
                  {!sending && canEditCertificate && (
                    <Button
                      variant='contained'
                      color='primary'
                      disableElevation
                      className={classes.addButton}
                      onClick={() => openModal(null)}
                    >
                      <AddIcon /> Adicionar
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderListCertification()}</TableBody>
          </Table>
          {canSendToAssignCertificate && checkedCertification.length > 0 && (
            <Grid container component={Box} p={3} bgcolor='rgba(0, 0, 0, 0.05)' item xs={12} style={{marginBottom: '3rem'}}>
              <Grid item xs={12} md={4} >
                <Button
                  size='small'
                  className={classes.btnSignatureLine}
                  onClick={() => sendToAssign()}
                >
                  <img
                    alt=''
                    src={process.env.PUBLIC_URL + '/img/signature.png'}
                    style={{ height: '30px' }}
                  />
                  Enviar para assinatura
                </Button>
              </Grid>
              <Grid item xs={12} md={8}>
                {!loadingDirector &&
                  <TextField
                    select
                    fullWidth
                    label="Diretor"
                    margin={"dense"}
                    style={{margin:'0'}}
                    value={directorToSign}
                    onChange={handleChangeDirector}
                    SelectProps={{
                      native: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant="filled"
                  >
                    {directors.filter(director => !director.hide).map((director) => (
                      <option key={director.cdUsuario} value={director.cdUsuario}>
                        {director.nmUsuario}
                      </option>
                    ))}
                  </TextField>
                }
              </Grid>
            </Grid>
            )}
        </div>
      )}
    </>
  );
}

export default injectIntl(LineCertification);
